<template>
  <v-container>
    <div v-if="loading">
      <v-progress-circular indeterminate />
    </div>
    <v-card v-else class="mx-auto" max-width="400" tile>
      <v-list-item v-for="contact in contacts" :key="contact._id">
        <v-list-item-content>
          <v-list-item-title>{{ contact.email }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => {
    return {
      contacts: null,
      loading: false
    };
  },
  async mounted() {
    console.log("Contacts mounted");
    this.loading = true;
    const response = await fetch(`${process.env.VUE_APP_BACKEND}/emails`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user-token")}`
      }
    });

    this.contacts = await response.json();
    console.log(this.contacts);

    this.loading = false;
  }
};
</script>

<style></style>
